<template lang="pug">
GenericCard.goals-panel(size='75')
  .px-4.py-4
    .text-large เป้าหมายและค่าคอมมิชชั่น
    .d-flex.px-3.pt-4
      template(v-if='user')
        img.rounded-circle(:src='user.imgSrc' height='128' width='128')

        .detail.ml-4.pl-3
          .text-large {{ user.name }}
          .d-flex.mt-2
            DataItem.mr-4( title='รหัส' :value='user.code' )
            DataItem.ml-4( title='เขต' :value='user.zone' )
          .d-flex.mt-3
            DataItem.mr-4( title='email' :value='user.email' )
            DataItem.ml-4( title='เบอร์ติดต่อ' :value='user.phone' )
  hr.m-0

  LoadedContentWrapper(
    :isLoading='isLoading'
    :data='goalDashboard'
    @reload='loadData'
  )
    template(v-if='goalDashboard.today')
      .d-flex.py-3.justify-content-center
        ProfilePerformanceStatItem(
          title='ค่าคอมมิชชั่น'
          :value='goalDashboard.today.total_commission'
          color='#E02020'
          :iconSrc='require(`@/assets/icons/investment.svg`)'
        )
        ProfilePerformanceStatItem.ml-1(
          title='ยอดขายวันนี้'
          :value='goalDashboard.today.total_sale'
          :iconSrc='require(`@/assets/icons/profits.svg`)'
        )

    template(v-if='goalDashboard.month')
      .blue-gradient.px-4.py-4
        .text-large
          | เป้าหมายประจำเดือน
          |
          small.text-secondary {{$moment().format('MMMM YYYY')}}
        .d-flex.py-2.justify-content-center
          ProfilePerformanceStatItem(
            title='เป้าหมาย'
            :value='goalDashboard.month.goal'
            :iconSrc='require(`@/assets/icons/target.svg`)'
          )
          ProfilePerformanceStatItem.ml-1(
            title='ยอดขายที่ทำได้'
            color='#E02020'
            :value='goalDashboard.month.total_sale'
          )

        .px-4.mx-3
          .progress.mt-3
            .progress-bar(
              :style='`width: ${progressPercentCalc}%`'
            )
          .d-flex.justify-content-between.mt-2
            .text-19.text-turquoise.font-weight-500
              | {{ (goalDashboard.month.total_sale) | currency }}
            .text-19.text-blue.font-weight-500
              | {{ (goalDashboard.month.goal) | currency }}

    hr.m-0

    .px-4.py-4
      .d-flex
        .text-large.mt-1.mr-2 สถิติการขาย
        div: CustomDatePicker.text-large.mx-auto(v-model='filterDate')

      template(v-if="goalDashboard.dynamic")
        .d-flex.py-2.justify-content-center
          ProfilePerformanceStatItem(
            title='ค่าคอมมิชชั่นสะสม'
            :value='goalDashboard.dynamic.total_commission'
            color='#E02020'
            :iconSrc='require(`@/assets/icons/investment.svg`)'
          )
          ProfilePerformanceStatItem.ml-1(
            title='ยอดขายสะสม'
            :value='goalDashboard.dynamic.total_sale'
            :iconSrc='require(`@/assets/icons/profits.svg`)'
          )
        .d-flex.py-2.px-3.justify-content-between
          NumberWithDescription(
            :number='goalDashboard.dynamic.orders.total'
            description='รายการขาย'
          )
          NumberWithDescription(
            :number='goalDashboard.dynamic.orders.back_orders'
            description='รายการ Back Order'
          )
          NumberWithDescription(
            :number='goalDashboard.dynamic.orders.cancelled'
            description='รายการยกเลิก'
          )

    .blue-gradient.d-flex.justify-content-center.px-4.py-4
      .d-flex.flex-column
        .text-large กลุ่มสินค้าขายดี
        GenericCard.pr-4.flex-fill.scrollable(size='40' style='margin-left: -12px;')
          div(style='max-height: 75vh')
            //- img.w-100.py-4.px-2(src='@/assets/_mock/graph.svg')
            template(v-if="bestSellingsGroupRatio")
              GraphBestSellingProductGroup.mt-3(:groupsData="bestSellingsGroupRatio")

            template(v-if="bestSellingsTableData")
              CustomTable.px-2(
                :columns='bestSellingsTableColumns'
                :data='bestSellingsTableData'
              )

      .d-flex.flex-column.pl-2
        .text-large ลูกค้าที่มียอดซื้อสะสมสูงสุด
        GenericCard.pl-0.pr-0.flex-fill(size='27')
          div(style='max-height: 75vh')
            .border-bottom.p-3.d-flex(v-for="buyer in bestBuyers")
              CustomerPicture(:src='buyer.image' :grade='buyer.grade')
              .flex-fill.px-3
                p.h6 {{buyer.name}}
                .font-weight-normal.text-secondary
                  small ยอดซื้อสะสม
                .h5.text-danger.m-0
                  | {{ buyer.total | currency }}

  modal(
    name='product-group-stat'
    width='90%' height='auto'
    transition='modal-transition'
  )
    ProductGroupStat(
      :productGroup='selectedProductGroup'
      :ranking='selectedProductGroupIndex+1'
      @closeButtonClicked='hideModal'
    )

</template>

<script>
import ProfilePerformanceStatItem from '../ProfilePerformanceStatItem.vue';
import GraphBestSellingProductGroup from '@/components/GraphBestSellingProductGroup.vue';
import CustomerShortDetailButton from '@/components/profile-performance/CustomerShortDetailButton.vue';
import CustomerPicture from '@/components/customers/CustomerPicture.vue';

import ProductGroupStat from '@/components/history/dialogs/BestSellings/ProductGroupStat.vue';

export default {
  props: {
    user: {
      default: () => ({}),
    },
  },
  data: () => ({
    daily: {
      commission: 31670.00,
      sales: 55123.00,
    },
    filterDate: '',

    MOCK_CUSTOMER: {
      name: 'บริษัท ซาฟารีเวิลด์ จำกัด (มหาชน)',
      total: '3,1670.00',
    },

    bestSellingsTableData: [],
    bestSellingsTableColumns: {
      name: { title: 'ชื่อ', align: 'left' },
      total: { title: 'ยอดรวม', align: 'right', type: Number },
    },

    bestSellingsGroupRatio: [],

    selectedProductGroup: [],
    selectedProductGroupIndex: -1,

    goalDashboard: {},

    isLoading: false,

    bestBuyers: [],
  }),
  mounted() {
    this.loadData();
  },
  watch: {
    filterDate() {
      this.loadData();
    },
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      const resGoalDashboard = await this.$api.user.goalDashboard({ ...this.filterDate });
      if (resGoalDashboard.status === 200) {
        this.goalDashboard = resGoalDashboard.data;

        // this.bestSellingsTableData;
        // this.bestSellingsTableColumns;

        const byGroup = {};

        this.goalDashboard.best_sellers.forEach((elm) => {
          const strPad = `00${elm.group_id}`;
          const groupName = strPad.substring(strPad.length - 2, strPad.length);
          if (!(groupName in byGroup)) byGroup[groupName] = [];
          byGroup[groupName].push(elm);
        });

        console.log(byGroup);

        // const sorted = []; //

        const byGroupTable = [];

        Object.keys(byGroup).forEach((key) => {
          const obj = { group_id: key, name: key, total: 0 }; // TODO: find group name
          byGroup[key].forEach((elm) => {
            obj.name = elm.group_name;
            obj.total += parseFloat(elm.total);
          });
          byGroupTable.push(obj);
        });

        this.bestSellingsTableData = byGroupTable;

        // let wholeTotal = 0;
        // byGroupTable.forEach((elm) => { wholeTotal += elm.total; });

        this.bestSellingsGroupRatio = byGroupTable.map(elm => ({
          group: elm.group_id,
          value: elm.total,
        }));

        this.bestBuyers = [];
        this.goalDashboard.best_buyers.forEach((elm) => {
          this.bestBuyers.push({
            name: elm.customer_name,
            image: elm.avatar,
            grade: elm.grade,
            total: elm.total,
          });
        });

        this.isLoading = false;
      }
      // const res = await this.$api.user.bestSellingsList();
      // if (res.status === 200) {
      //   this.bestSellingsTableData = res.data.data;
      // }

      // const resProductGroup = await this.$api.user.bestSellingsGroupRatio();
      // if (res.status === 200) {
      //   this.bestSellingsGroupRatio = resProductGroup.data.data;
      // }
    },
    bestSellingClicked(e) {
      this.selectedProductGroup = e.data;
      this.selectedProductGroupIndex = e.index;
      this.$modal.show('product-group-stat');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('product-group-stat');
    },
  },
  computed: {
    progressPercentCalc() {
      const percentage = this.goalDashboard.month.total_sale / this.goalDashboard.month.goal * 100;

      if (this.goalDashboard.month.goal === 0 || percentage > 100) {
        return 100;
      }
      return percentage;
    },
  },
  components: {
    ProfilePerformanceStatItem,
    CustomerShortDetailButton,
    ProductGroupStat,
    GraphBestSellingProductGroup,
    CustomerPicture,
  },
};
</script>

<style lang="scss">
// .goals-panel {}
</style>
